<template>
  <div class="row">
    <div class="col-md-12">
      <TableWrapper
        :columns="columns"
        :mod-count="modCount"
        :url="url"
        :search-form-fields="formFields"
        :offset-height="offsetHeight"
        :show-add="showAdd"
        :show-del="false"
        @on-add="showFormModalDialog"
      />
      <ContractDetails
        :id="entityId"
        :visible="modalForm"
        :width="950"
        :action="url"
        @on-close="onModalClose"
      />
    </div>
  </div>
</template>

<script>
import TableWrapper from '@/components/table-wrapper'
import ContractDetails from './dialog/contract-details'
import request from '@/utils/request'
export default {
  name: 'TokenList',
  components: {
    TableWrapper,
    ContractDetails
  },
  data() {
    return {
      url: this.$config.apiContextPath + '/contract',
      modalForm: false,
      entityId: 0,
      modCount: 0,
      showAdd: true
    }
  },
  computed: {
    offsetHeight() {
      return 280
    },
    formFields() {
      return {
        action: '',
        fields: [
          { label: '文档名称', placeholder: '请输入文档名称...', name: 'name', width: 'auto', type: 'input' }
        ]
      }
    },
    columns() {
      const that = this
      return [
        { title: '序号', type: 'index', width: 80, align: 'center' },
        { title: '文档编号', align: 'left', key: 'code', sortable: true, ellipsis: true },
        { title: '文档名称', align: 'left', key: 'name', sortable: true, ellipsis: true },
        { title: '文档描述', align: 'left', key: 'description', sortable: true, ellipsis: true, tooltip: true,
          render: (h, params) => {
            return h('span', {}, params.row.description || '---')
          }
        },
        // { title: '协议版本', align: 'center', key: 'version', sortable: true },
        { title: '创建时间', align: 'center', sortable: true, width: 160, key: 'createTime', ellipsis: true, tooltip: true },
        { title: '更新时间', align: 'center', sortable: true, width: 160, key: 'updateTime', ellipsis: true, tooltip: true },
        { title: '状态', align: 'center', key: 'status', sortable: true, ellipsis: true, tooltip: true,
          render: (h, params) => {
            return h('span', {
              style: { }
            }, params.row.status === 1 ? '启用' : '停用')
          }
        },
        { title: '操作', align: 'center', width: 185,
          render: (h, params) => {
            return h('div', [
              h('a', {
                style: { color: '#126D91', marginRight: '10px' },
                on: {
                  click: () => {
                    if (params.row.id) {
                      this.showFormModalDialog(params.row.id)
                    }
                  }
                }
              }, [
                h('i', { class: { 'fas': true, 'fa-edit': true, 'cell-icon-link': true }}),
                h('span', {}, '编辑')
              ]),
              that.showDel ? h('a', {
                style: { color: '#126D91' },
                on: {
                  click: () => {
                    if (params.row.id) {
                      this.showDelModalDialog(params.row.id, params.row.name)
                    }
                  }
                }
              }, [
                h('i', { class: { 'fas': true, 'fa-trash': true, 'cell-icon-link': true }}),
                h('span', {}, '删除')
              ]) : h()
            ])
          }
        }
      ]
    }
  },
  methods: {
    showFormModalDialog: function(id = '') {
      this.entityId = id ? parseInt(id) : 0
      this.modalForm = true
    },
    showDelModalDialog: function(id, name) {
      const _this = this
      this.$Modal.confirm({
        title: '确认删除文档么？',
        loading: true,
        render: (h, params) => {
          return h('ul', { style: { padding: '10px 25px 0' }}, [h('li', {}, name)])
        },
        onOk: function() {
          request({
            url: _this.url + '/' + id,
            method: 'DELETE'
          }).then(res => {
            this.$Notice.success({
              title: '数据删除成功',
              desc: '文档 `' + name + '` 删除成功!'
            })
            _this.modCount = _this.modCount + 1
            this.$Modal.remove()
          }).catch(error => {
            this.$Notice.error({
              title: '数据删除失败',
              desc: '文档 `' + name + '` 删除失败, 错误信息: ' + error
            })
          })
        }
      })
    },
    onModalClose: function(changed) {
      this.entityId = 0
      this.modalForm = false
      if (changed) {
        this.modCount = this.modCount + 1
      }
    }
  }
}
</script>

